import keyMirror from "keymirror";

const WorkReportConstants = {
	ActionTypes: keyMirror({
		
		// my daily report
		INCREASEDAILYREPORTLOADCOUNTER: null,
		SELECTDAILYREPORTSUCCESS: null,
		SETDAILYREPORTFILTERS: null,
		UPDATEDAILYREPORTSUCCESS: null,
		UPDATEDAILYREPORTSTATUSSUCCESS: null,

		// daily report management
		INCREASELEADERDAILYREPORTLOADCOUNTER: null,
		SELECTLEADERDAILYREPORTSUCCESS: null,
		SETLEADERDAILYREPORTFILTERS: null,
		UPDATELEADERDAILYREPORTSTATUSSUCCESS: null,

		// my weekly report
		INCREASEWEEKLYREPORTLOADCOUNTER: null,
		SELECTWEEKLYREPORTSUCCESS: null,
		SETWEEKLYREPORTFILTERS: null,
		UPDATEWEEKLYREPORTSUCCESS: null,
		UPDATEWEEKLYREPORTSTATUSSUCCESS: null,

		// my weekly question summary
		INCREASEWEEKLYQUESTIONSUMMARYLOADCOUNTER: null,
		SELECTWEEKLYQUESTIONSUMMARYSUCCESS: null,
		SETWEEKLYQUESTIONSUMMARYFILTERS: null,
		UPDATEWEEKLYQUESTIONSUMMARYSTATUSSUCCESS: null,

		// weekly report management
		INCREASELEADERWEEKLYREPORTLOADCOUNTER: null,
		SELECTLEADERWEEKLYREPORTSUCCESS: null,
		SETLEADERWEEKLYREPORTFILTERS: null,
		UPDATELEADERWEEKLYREPORTSTATUSSUCCESS: null,

		// my monthly report
		INCREASEMONTHLYREPORTLOADCOUNTER: null,
		SELECTMONTHLYREPORTSUCCESS: null,
		SETMONTHLYREPORTFILTERS: null,
		UPDATEMONTHLYREPORTSUCCESS: null,
		UPDATEMONTHLYREPORTSTATUSSUCCESS: null,

		// monthly report management
		INCREASELEADERMONTHLYREPORTLOADCOUNTER: null,
		SELECTLEADERMONTHLYREPORTSUCCESS: null,
		SETLEADERMONTHLYREPORTFILTERS: null,
		UPDATELEADERMONTHLYREPORTSTATUSSUCCESS: null,

		// template
		CHANGETEMPLATEMANAGEMENT: null,
		SELECTTEMPLATEMANAGEMENT: null,
		UPDATETEMPLATEMANAGEMENT: null,
	})
}

export default WorkReportConstants;


// WEBPACK FOOTER //
// ./src/constants/work-report-constants.js